import { toast } from 'react-toastify';

import { cloneDeep, getStatesByCountryValue, toastError, tryParseJSON } from '../../../../utils';
import {
     API_SUBSCRIBER_PROFILE,
     API_SUBSCRIBER_UPDATE_EMAIL_PRIMARY,
     DEFAULT_FN,
     INIT_UNSUBSCRIBE_EMAIL_GROUPS,
     PREFERENCES,
} from '../../../../constants';
import { callApi } from '../../../../apiCaller';

import { setIsLoading } from '../../../../actions/general';
import { LOCAL_TIME_ZONE } from '../../../../constants';
import { setSubscriberUserTimezone } from '../GlobalStates/CurrentUser/actions';
import { signOut } from '../../../../helpers/auth';

export const ADD_PROFILE_USER = 'addProfileUser';

let isToast = false;

export const addProfileUser = (profileUser) => {
     return {
          type: ADD_PROFILE_USER,
          payload: profileUser,
     };
};

export const fetchProfileUserRequest = (nextDispatch) => (dispatch) => {
     dispatch(setIsLoading(true));

     callApi(API_SUBSCRIBER_PROFILE, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    signOut();
                    return;
               }

               if (nextDispatch?.setListStates) {
                    nextDispatch.setListStates(getStatesByCountryValue(response.data.country));
               }

               dispatch(addProfileUser(response.data));
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const updateEmailUserRequest =
     (profileUser, setSubmitting = DEFAULT_FN) =>
     (dispatch) => {
          callApi(API_SUBSCRIBER_UPDATE_EMAIL_PRIMARY, 'PUT', profileUser).then((response) => {
               setSubmitting(false);

               if (response.status !== 200) {
                    toastError(response);
                    isToast = true;
                    return;
               }
               dispatch(addProfileUser(response.data));
               toast.success('Update successfully');
               setTimeout(() => {
                    signOut();
               }, 500);
          });
     };

export const updateProfileUserRequest =
     (payload, setSubmitting = DEFAULT_FN) =>
     async (dispatch) => {
          return await callApi(API_SUBSCRIBER_PROFILE, 'PUT', payload).then((response) => {
               setSubmitting(false);

               if (response.status !== 200) {
                    if (!isToast) {
                         toastError(response);
                    }
                    return;
               }

               const userRes = response.data;
               dispatch(addProfileUser(userRes));
               dispatch(setSubscriberUserTimezone(userRes.timezone));

               // Update timeZone LocalStorage
               const timeZone = response.data.timezone;
               localStorage.setItem(LOCAL_TIME_ZONE, timeZone);

               toast.success('Update successfully');
               return userRes;
          });
     };

export const updateEmailPreferences = (nextDispatch) => (dispatch, getState) => {
     const profileUser = getState().subscriber.profileUser;

     const emailUnsubscribes = tryParseJSON(profileUser?.unsubscribe);
     const { currentValue, index, emailPreferences, setEmailPreferences = DEFAULT_FN } = nextDispatch;
     const newEmailPreferences = [...emailPreferences];

     newEmailPreferences[index] = currentValue;
     setEmailPreferences(newEmailPreferences);

     // Handle update profile user with unsubscribe email
     const unsubscribeEmailGroups = cloneDeep(emailUnsubscribes || INIT_UNSUBSCRIBE_EMAIL_GROUPS);

     switch (currentValue) {
          case PREFERENCES.RECEIVING:
               unsubscribeEmailGroups[index].suppressed = false;
               break;

          case PREFERENCES.NOT_RECEIVING:
               unsubscribeEmailGroups[index].suppressed = true;
               break;

          default:
               break;
     }

     const newProfileUser = {
          unsubscribe: JSON.stringify(unsubscribeEmailGroups),
     };

     dispatch(updateProfileUserRequest(newProfileUser));
};
